var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/\n_/ Starbright App Cascading Style Sheets\n_/\n_/ Created by NICE+DAY, Inc. [13/10/2018]\n_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/\n*/\n/*\n_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/\n_/ Starbright Cascading Style Sheets Property\n_/\n_/ Created by NICE+DAY, Inc. [18/08/2018]\n_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/\n*/\n/* ////////////////////////////////////\n// common setting\n//////////////////////////////////// */\n#cover {\n  position: fixed;\n  top: 0;\n  left: calc((100vw - calc(100vh * 530 / 760)) / 2);\n  width: calc(100vh * 530 / 760);\n  height: 100vh;\n  background-image: url(" + escape(require("../assets/img/pages/bg.png")) + ");\n  background-size: cover;\n  animation-name: fadeOut;\n  animation-duration: 2.0s;\n  animation-delay: 4.0s;\n  animation-iteration-count: 1;\n  animation-fill-mode: forwards;\n  z-index: 10000; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main